<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="flex flex-wrap items-center mb-base">
        <img
          :src="
            formData.file !== null
              ? formData.file.includes('upload//')
                ? `${url.baseFl}/${formData.file}`
                : formData.file
              : formData.file
          "
          alt="Banner-img"
          class="rounded-lg shadow-md cursor-pointer block w-full mb-4"
        />
        <div class="vx-row w-full justify-between items-start">
          <div class="vx-col sm:w-full lg:w-1/2 xl:w-1/2 flex justify-start">
            <input
              type="file"
              class="hidden"
              ref="updateImgInput"
              @change="updateCurrImg"
              accept="image/*"
            />
            <vs-button class="mr-4 sm:mb-0 mb-2" @click="$refs.updateImgInput.click()"
              >Upload Photo Banner</vs-button
            >
            <!-- <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p> -->
          </div>
          <div class="vx-col sm:w-full lg:w-1/2 xl:w-1/2 flex justify-end">
            <p class="text-red">Ukuran Rekomendasi : 1365 x 404</p>
          </div>
        </div>
      </div>
      <!-- Info -->
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nama Banner</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="banner name"
          class="w-full sidebar-input"
          v-model="formData.name"
          placeholder="Isi Nama Banner"
        />
        <span class="text-danger text-sm">{{ errors.first("banner name") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Status</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="[
            { id: 1, text: 'Aktif' },
            { id: 0, text: 'Tidak Aktif' },
          ]"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="status"
          label="text"
          v-model="formData.status"
          placeholder="Pilih Status Akun"
        />
        <span class="text-danger text-sm">{{ errors.first("status") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Deskripsi</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-textarea
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="description"
          class="w-full sidebar-input"
          v-model="formData.deskripsi"
          placeholder="Isi Deskripsi Banner"
        />
        <span class="text-danger text-sm">{{ errors.first("description") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>URL</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="url"
          class="w-full sidebar-input"
          v-model="formData.url"
          placeholder="Isi URL Banner"
        />
        <span class="text-danger text-sm">{{ errors.first("url") }}</span>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          :disabled="!validateForm"
          @click="addWithOption"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  components: {
    VuePhoneNumberInput,
  },
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      url,
      emptyImage,
      formData: {
        status: null,
        name: "",
        deskripsi: "",
        url: "",
        file: emptyImage,
      },
      binaryFile: "",
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Banner Donasi" : "Tambah Banner Donasi";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.name !== "" &&
        this.formData.status !== null &&
        this.formData.file !== "" &&
        this.formData.deskripsi !== ""
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.formData.name = this.passData.name;
        this.formData.status = this.passData.status;
        this.formData.url = this.passData.url;
        this.formData.file = this.getPathFoto(this.passData);
        this.formData.deskripsi = this.passData.deskripsi;
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.formData.name = "";
      this.formData.status = null;
      this.formData.url = "";
      this.formData.file = this.emptyImage;
      this.formData.deskripsi = "";
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addWithOption() {
      this.$vs.loading({
        color: "primary",
      });
      console.log(this.passData);
      if (this.binaryFile === "") {
        this.addData();
      } else {
        this.addWithFile();
      }
    },
    addWithFile() {
      this.$store
        .dispatch("file/addFile", this.binaryFile)
        .then((v) => {
          this.formData.file = v.link;
          this.addData();
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.binaryFile = "";
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addData() {
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      if (this.formData.file === emptyImage) {
        this.formData.file = null;
      }
      this.$store
        .dispatch("banner/cudBannerPPOB", [{ ...this.formData, ...id }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Banner Donasi Sukses!"
                : "Tambah Banner Donasi Sukses!",
            text:
              this.passData !== null
                ? `Banner Donasi ${v.name} Berhasil diedit`
                : `Banner Donasi ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();

          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.file = e.target.result;
          this.binaryFile = input.target.files[0];
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
  },
};
</script>

<style scoped>
.text-red {
  color: red;
}
.text-blue {
  color: blue;
}
.text-grey-black {
  color: rgb(70, 70, 70);
}
img {
  max-height: 270px;
  overflow: auto;
  object-fit: cover;
}
</style>
